const SELECT_ALL_VALUE = 'all';
const PLACEHOLDER_VALUE = 'helperText';
const PLACEHOLDER_DISPLAY_TITLES = Object.freeze({
  deliveryOption: 'All Types',
  orderStatus: 'All Status',
  defaultSelectAll: 'All Options',
  pleaseSelect: 'Please Select',
});

// For the Available Locations dropdown
const clickedRegularOptionWhileSelectAllIsSelected = (
  newSelectedIds,
  currentSelectedIds,
  dropdownOptions,
) => (
  isAllInSelectedValues(newSelectedIds)
  && areBothSelectAllAndAllOptionsSelected(dropdownOptions, currentSelectedIds)
);

const isAllInSelectedValues = selectedIds => Array.isArray(selectedIds) && selectedIds.includes('all');

const isOneMoreOptionThanAllOptionsSelected = (dropdownOptions, selectedIds) => (
  Array.isArray(dropdownOptions)
  && Array.isArray(selectedIds)
  && selectedIds.length === dropdownOptions.length + 1
);

const areBothSelectAllAndAllOptionsSelected = (dropdownOptions, selectedIds) => (
  isAllInSelectedValues(selectedIds)
  && isOneMoreOptionThanAllOptionsSelected(dropdownOptions, selectedIds)
);

/**
 * For the Available Locations dropdown, not the Out of Stock dropdowns
 * An empty array means to the API that a product is available at all locations.
 */
const allLocationsAreSelected = (selectedIds, dropdownOptions) => (
  Array.isArray(selectedIds)
  && Array.isArray(dropdownOptions)
  && (selectedIds.length === 0 || selectedIds.length === dropdownOptions.length)
);

// Functions applying to all dropdowns

const getSelectedNamesFromArray = (selectedOptions, nameLookupKey) => {
  const selectedOptionNames = selectedOptions.map(option => (option && option[nameLookupKey] ? option[nameLookupKey] : ''));
  const removeEmptyValues = selectedOptionNames.filter(name => !!name);
  return removeEmptyValues.join(', ');
};
const getSelectedNameFromOtherType = (selectedOption, nameLookupKey) => {
  // Happens for single select placeholder options, whose ids are "helperText"
  if (typeof selectedOption === 'string') return PLACEHOLDER_DISPLAY_TITLES.pleaseSelect;
  return (selectedOption && selectedOption[nameLookupKey]) || '';
};

const getSelectedNameFunctions = {
  array: getSelectedNamesFromArray,
  other: getSelectedNameFromOtherType,
};

const removeSelectAllFromSelectedOptions = (newSelectedIds) => {
  if (!Array.isArray(newSelectedIds)) return newSelectedIds;
  const selectedValuesCopy = newSelectedIds.slice(0);
  return selectedValuesCopy.filter(val => val !== 'all');
};

export {
  allLocationsAreSelected,
  clickedRegularOptionWhileSelectAllIsSelected,
  getSelectedNameFunctions,
  removeSelectAllFromSelectedOptions,
  SELECT_ALL_VALUE,
  PLACEHOLDER_DISPLAY_TITLES,
  PLACEHOLDER_VALUE,
};
